import React from 'react';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        fill: ({ color }) => (color ? palette[color].main : 'black'),
    },
    small: {
        height: spacing(1),
        width: spacing(2),
    },
    medium: {
        height: 20,
        width: 20,
    },
    mediumLarge: {
        height: spacing(1.5),
        width: spacing(3),
    },
    large: {
        height: spacing(2),
        width: spacing(4),
    },
    xl: {
        height: spacing(3),
        width: spacing(6),
    },
    dotOne: {
        animation: '$pulse 900ms infinite alternate',
        animationDelay: '300ms',
    },
    dotTwo: {
        animation: '$pulse 900ms infinite linear alternate',
    },
    dotThree: {
        animation: '$pulse 900ms infinite alternate',
        animationDelay: '900ms',
    },
    '@keyframes pulse': {
        '0%': { opacity: 1 },
        '100%': { opacity: 0.2 },
    },
}));
function LoadingDots({ size = 'medium', color }) {
    const classes = useStyles({ color });
    return (React.createElement("svg", { className: classes[size], viewBox: "0 0 120 60" },
        React.createElement("g", { className: classes.root },
            React.createElement("circle", { className: classes.dotOne, cy: "30", cx: "20", r: "15" }),
            React.createElement("circle", { className: classes.dotTwo, cy: "30", cx: "60", r: "15" }),
            React.createElement("circle", { className: classes.dotThree, cy: "30", cx: "100", r: "15" }))));
}
export default LoadingDots;
//# sourceMappingURL=LoadingDots.js.map